import React from 'react';
import { Button } from '../../../../common/components';

const QuoteSavePolicy = ({ saveAndExit, isSaving, show }) => {
  if (!show) {
    return null;
  }

  return (
    <Button
      label={'Save and Exit'}
      bsStyle={'secondary'}
      block={true}
      isLoading={isSaving}
      handleClick={saveAndExit}
      rightIcon="save"
    />
  );
};

export default QuoteSavePolicy;
